import { ADMIN } from "../../constants/testIds";

export const TrackBreakdownWidget = ({ data, loading }) => {
  const rows = data?.track_breakdown || [];

  return (
    <div className="p-5 sm:p-6 rounded-xl border border-slate-800 bg-slate-900/80 backdrop-blur-md">
      <h3 className="text-lg font-semibold text-slate-200 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
        Per-Track Skip vs Completion <span className="text-xs text-slate-500 font-normal">(sorted by most-skipped)</span>
      </h3>
      {loading ? (
        <p className="text-sm text-slate-500">Loading…</p>
      ) : rows.length === 0 ? (
        <p className="text-sm text-slate-500">No track playback events recorded yet.</p>
      ) : (
        <table data-testid={ADMIN.trackBreakdownTable} className="w-full text-sm">
          <thead>
            <tr className="text-slate-500 text-xs uppercase tracking-wider font-mono">
              <th className="text-left py-2">Track</th>
              <th className="text-right py-2">Completes</th>
              <th className="text-right py-2">Skips</th>
              <th className="text-right py-2 w-40">Completion</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const total = r.completes + r.skips;
              const skipRate = total ? (r.skips / total) * 100 : 0;
              const flagged = total > 0 && skipRate > 50;
              return (
                <tr
                  key={r.title}
                  data-testid={flagged ? ADMIN.trackRowHighSkip : undefined}
                  className={`border-t ${flagged ? "border-red-500/20 bg-red-500/5" : "border-white/5"}`}
                >
                  <td className={`py-2 flex items-center gap-2 ${flagged ? "text-red-300" : "text-slate-300"}`}>
                    {flagged && <span className="inline-block w-1.5 h-1.5 rounded-full bg-red-500 shrink-0" title="High skip rate" />}
                    {r.title}
                  </td>
                  <td className="py-2 text-right text-emerald-400 font-mono">{r.completes}</td>
                  <td className={`py-2 text-right font-mono ${flagged ? "text-red-400 font-semibold" : "text-amber-400"}`}>{r.skips}</td>
                  <td className="py-2 text-right">
                    <div className="flex items-center justify-end gap-2">
                      <div className="w-24 h-1.5 rounded-full bg-white/10 overflow-hidden">
                        <div className={`h-full ${flagged ? "bg-red-500" : "bg-emerald-500"}`} style={{ width: `${r.completion_rate}%` }} />
                      </div>
                      <span className={`text-xs w-10 font-mono ${flagged ? "text-red-400" : "text-slate-400"}`}>{r.completion_rate}%</span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};
